import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

// @mui
import { Grid } from '@mui/material';
import ShopProductCard from './ProductCard';
// eslint-disable-next-line import/no-unresolved
// Api

// ----------------------------------------------------------------------

ProductList.propTypes = {
  products: PropTypes.array.isRequired,
};

export default function ProductList({ products, reLoad, load, openModal, onDelete, ...other }) {

  const handleDeleteModal = () => {
    alert("delet Item")
  }



  return (
    <>
      <Grid container spacing={3} {...other}>
        {products.map((product) => (
          <Grid key={product.id} item xs={12} sm={6} md={3}>
            <ShopProductCard product={product} onOpen={openModal} onDelete={onDelete} foodId={product} load={load} foodVarient={product} reLoad={reLoad} />
          </Grid>
        ))}
      </Grid>

    </>
  );
}
